import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var LanguageType;
(function (LanguageType) {
    LanguageType["NONE"] = "NONE";
    LanguageType["ALL"] = "ALL";
    LanguageType["DE"] = "DE";
    LanguageType["IT"] = "IT";
    LanguageType["FR"] = "FR";
})(LanguageType || (LanguageType = {}));
export var ImageType;
(function (ImageType) {
    ImageType["NATIVE16X9"] = "NATIVE16X9";
    ImageType["NATIVE4X3"] = "NATIVE4X3";
    ImageType["NATIVE1X1"] = "NATIVE1X1";
    ImageType["BANNER"] = "BANNER";
    ImageType["NEWSLETTER_NATIVE"] = "NEWSLETTER_NATIVE";
})(ImageType || (ImageType = {}));
export var VideoType;
(function (VideoType) {
    VideoType["IN_STREAM"] = "IN_STREAM";
    VideoType["OUT_STREAM"] = "OUT_STREAM";
    VideoType["VAST"] = "VAST";
    VideoType["VPAID"] = "VPAID";
    VideoType["SELF_HOSTED"] = "SELF_HOSTED";
})(VideoType || (VideoType = {}));
export var CreativeStatus;
(function (CreativeStatus) {
    CreativeStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CreativeStatus["BATCH_ERROR"] = "BATCH_ERROR";
    CreativeStatus["DRAFT"] = "DRAFT";
    CreativeStatus["APPROVED"] = "APPROVED";
    CreativeStatus["REJECTED"] = "REJECTED";
    CreativeStatus["SUSPENDED"] = "SUSPENDED";
    CreativeStatus["ARCHIVED"] = "ARCHIVED";
    CreativeStatus["TO_REMOVE"] = "TO_REMOVE";
})(CreativeStatus || (CreativeStatus = {}));
export var HistoryType;
(function (HistoryType) {
    HistoryType["UPDATE"] = "UPDATE";
    HistoryType["AD_SERVER_CREATE"] = "AD_SERVER_CREATE";
    HistoryType["AD_SERVER_UPDATE"] = "AD_SERVER_UPDATE";
    HistoryType["AD_SERVER_DELETE"] = "AD_SERVER_DELETE";
    HistoryType["DEACTIVATE"] = "DEACTIVATE";
    HistoryType["AD_SERVER_SYNC"] = "AD_SERVER_SYNC";
})(HistoryType || (HistoryType = {}));
export var HistoryDataType;
(function (HistoryDataType) {
    HistoryDataType["TEXT"] = "TEXT";
    HistoryDataType["NUMBER"] = "NUMBER";
    HistoryDataType["BOOLEAN"] = "BOOLEAN";
    HistoryDataType["DATE"] = "DATE";
    HistoryDataType["ENUM"] = "ENUM";
    HistoryDataType["LIST"] = "LIST";
    HistoryDataType["JSON"] = "JSON";
    HistoryDataType["ENTITY"] = "ENTITY";
})(HistoryDataType || (HistoryDataType = {}));
export var CreativeType;
(function (CreativeType) {
    CreativeType["HTML_ZIP"] = "HTML_ZIP";
    CreativeType["HTML_TAG"] = "HTML_TAG";
    CreativeType["BANNER"] = "BANNER";
    CreativeType["NATIVE"] = "NATIVE";
    CreativeType["VIDEO"] = "VIDEO";
    CreativeType["NATIVE_VIDEO"] = "NATIVE_VIDEO";
    CreativeType["NEWSLETTER_NATIVE"] = "NEWSLETTER_NATIVE";
    CreativeType["NEWSLETTER_DISPLAY"] = "NEWSLETTER_DISPLAY";
    CreativeType["AC"] = "AC";
})(CreativeType || (CreativeType = {}));
export var ImageSizeType;
(function (ImageSizeType) {
    ImageSizeType["STANDARD"] = "STANDARD";
    ImageSizeType["MOBILE"] = "MOBILE";
    ImageSizeType["CUSTOM"] = "CUSTOM";
})(ImageSizeType || (ImageSizeType = {}));
export var ThirdPartyPixelFormat;
(function (ThirdPartyPixelFormat) {
    ThirdPartyPixelFormat["RAW_JS"] = "RAW_JS";
    ThirdPartyPixelFormat["URL_HTML"] = "URL_HTML";
    ThirdPartyPixelFormat["URL_JS"] = "URL_JS";
    ThirdPartyPixelFormat["URL_IMAGE"] = "URL_IMAGE";
    ThirdPartyPixelFormat["RAW_URL"] = "RAW_URL";
})(ThirdPartyPixelFormat || (ThirdPartyPixelFormat = {}));
export var AcTemplateState;
(function (AcTemplateState) {
    AcTemplateState["ACTIVE"] = "ACTIVE";
    AcTemplateState["INACTIVE"] = "INACTIVE";
})(AcTemplateState || (AcTemplateState = {}));
export var AcTemplateMacroType;
(function (AcTemplateMacroType) {
    AcTemplateMacroType["STRING"] = "STRING";
    AcTemplateMacroType["URL"] = "URL";
    AcTemplateMacroType["INTEGER"] = "INTEGER";
    AcTemplateMacroType["DECIMAL"] = "DECIMAL";
    AcTemplateMacroType["TRUE_FALSE"] = "TRUE_FALSE";
    AcTemplateMacroType["SELECT_FROM_LIST"] = "SELECT_FROM_LIST";
    AcTemplateMacroType["FILE"] = "FILE";
    AcTemplateMacroType["HTML"] = "HTML";
    AcTemplateMacroType["ADAPTIVE_VIDEO"] = "ADAPTIVE_VIDEO";
})(AcTemplateMacroType || (AcTemplateMacroType = {}));
export var AcSystemMacro;
(function (AcSystemMacro) {
    AcSystemMacro["AC_CLICK_URL"] = "AC_CLICK_URL";
    AcSystemMacro["AC_CLICK_URL_ENC"] = "AC_CLICK_URL_ENC";
    AcSystemMacro["AC_CACHEBUSTER"] = "AC_CACHEBUSTER";
    AcSystemMacro["AC_WIDTH"] = "AC_WIDTH";
    AcSystemMacro["AC_HEIGHT"] = "AC_HEIGHT";
})(AcSystemMacro || (AcSystemMacro = {}));
